<template>
  <address-card :list="list" @handleDel="handleDel"></address-card>
  <router-link class="out-login" :to="{ name: 'addAddress' }">
    新增地址
  </router-link>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import AddressCard from "@/components/common/AddressCard.vue";
import axios from "@/api/axios";
import qs from "qs";
import Toast from "@/components/UI/Toast";
export default defineComponent({
  name: "Address",
  components: {
    AddressCard,
  },
  setup() {

    const list = ref<object>([]);

    

    function getList() {
      axios.get("/M/User/Address").then(res => {
          console.log(res)
          list.value = res.data.obj.list;
      }).catch(err => {
          console.log(err)
      })
    }

    getList()

    function handleDel(id: string) {
      const data = qs.stringify({
        id
      });
      axios.post("/M/Server/DoDelAddress", data).then(res => {
          console.log(res)
          Toast({
            type: "success",
            title: "删除成功！",
           });
          getList()
      }).catch(err => {
          console.log(err)
      })
    }
    
    return {
      list,
      handleDel
    }
  },
});
</script>

<style lang="scss" scoped>
.out-login {
    width: 345px;
    display: block;
    margin: 30px auto;
    height: 45px;
    background-color: #d64b4b;
    box-shadow: 0px 4.988px 10.013px 0px rgba(0, 0, 0, 0.3);
    border-radius: 3.75px;
    line-height: 45px;
    text-align: center;
    color: #ffffff;
    border: none;
    outline: none;
    font-size: 15px;
}
</style>